import { Pipe, PipeTransform } from '@angular/core';
import { CONFIG } from '../store/reducer/config.reducer';

@Pipe({
    name: 'basketFilter',
    standalone: false
})
export class BasketFilterPipe implements PipeTransform {
  transform(parts: any[], basket: any, config: CONFIG) {
    if (config['isPartsVisible']) return parts;
    const _basket = [];
    Object.keys(basket).map((uid) => {
      Object.keys(basket[uid]).map((page) => {
        Object.keys(basket[uid][page]).map((id) => {
          _basket.push({
            uid,
            currentPageNumber: page,
            count: basket[uid][page][id]['count'],
            ...basket[uid][page][id]['actualItem'],
          });
        });
      });
    });

    return _basket;
  }
}
